import * as React from "react";
import { useCallback, useImperativeHandle, useMemo, useState } from "react";
import MenuItem from "components/bootstrap/menuitem/MenuItem";
import AddNotesBulk from "security-app/components/SecurityEvents/Alerts/AlertsModals/AddNotesModal/AddNotesBulk";
export const BulkAddNotesModal = React.forwardRef(({ events }, ref) => {
  const [showModal, setShowModal] = useState(false);
  const eventIds = useMemo(() => events.map((event) => event.id), [events]);
  const onClose = useCallback(() => setShowModal(false), []);
  useImperativeHandle(ref, () => ({
    toggle: () => setShowModal(true)
  }));
  return /* @__PURE__ */ React.createElement(AddNotesBulk, { eventIds, onClose, show: showModal });
});
export const BulkAddNotesAction = ({ modalRef }) => {
  const onClick = useCallback(() => modalRef().toggle(), [modalRef]);
  return /* @__PURE__ */ React.createElement(MenuItem, { onClick }, "Add notes");
};
